import type { JoinWindow, JoinWindowState } from '../api/learner';

/**
 * Where a governed join window stands at `now` — the one client copy of the
 * comparison. Mirrors the server's rule (booking/domain/rules/join-window.ts)
 * over the instants the server sent; no minute value appears here
 * (S08-PAR-03). Every screen that offers "Entrar" — the learner's door, "Mis
 * clases", the parent's progress — asks this, with the server's clock.
 */
export function joinStateAt(window: JoinWindow, now: Date): JoinWindowState {
  const t = now.getTime();
  if (t < new Date(window.opensAt).getTime()) return 'BEFORE_WINDOW';
  if (window.closesAt && t >= new Date(window.closesAt).getTime()) return 'ENDED';
  if (t > new Date(window.lateAfter).getTime()) return 'LATE';
  return 'OPEN';
}
